import styled from 'styled-components';

import { ModalContainer } from '@/shared/components/ui/modal-controller/modal-controller.styled';

export const FullScreenLoaderModalContainer = styled(ModalContainer)`
  && {
    background-color: ${({ theme }) => theme.palette.background.overlay};
    pointer-events: none;
    min-width: 0;
    width: 100vw;
    height: 100vh;
    max-height: none;
    padding: 0;
    overflow: hidden;
    gap: 1rem;

    p {
      color: ${({ theme }) => theme.palette.primary.contrastText};
    }

    &:focus {
      outline: none;
    }
  }
`;
